module.exports = __webpack_public_path__ + "img/TrustBy_DGMC.f878c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/professional/TrustBy_DGMC.png
// module id = 603
// module chunks = 5